import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"variable\":\"--font-montserrat\",\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/AuthPanel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SnackbarProviderWrapper"] */ "/app/src/app/providers/SnackbarProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/src/app/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/SessionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ThemeRegistry.tsx");
